import { render, staticRenderFns } from "./bindStudentDialog.vue?vue&type=template&id=69d37714&"
import script from "./bindStudentDialog.vue?vue&type=script&lang=js&"
export * from "./bindStudentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports